import { render, staticRenderFns } from "./ContactType.vue?vue&type=template&id=f931a186&scoped=true&"
import script from "./ContactType.vue?vue&type=script&lang=js&"
export * from "./ContactType.vue?vue&type=script&lang=js&"
import style0 from "./ContactType.vue?vue&type=style&index=0&id=f931a186&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f931a186",
  null
  
)

export default component.exports